import TestPrice from "@/src/components/common/test-search/testPrice";
import Link from "next/link";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";

const FindTestCard = ({ item }) => {
    const isMobile = useBreakpoint("sm");

    return (
        <Link href={`/test/${item?.productDetails?.urlSlug}`}>
            <div className="book_test_col hover:border-primary flex pt-3.5 pb-12 md:pt-3 md:pb-3 px-4 md:mb-3 mb-4 md:items-center relative items-start md:flex-row flex-col">
                <div className="col__1 pr-7">
                    <h3 className="md:!leading-6 !leading-4 md:text-lg text-sm pb-0 text-base text-black font-bold ">
                        {item?.productDetails?.productName}
                    </h3>
                    <p className="!leading-none flex items-center text-xs py-1.5 md:py-0 text-gray-600 md:text-xs">
                        {item?.productDetails?.categoryType
                            ?.charAt(0)
                            ?.toUpperCase() +
                            item?.productDetails?.categoryType?.slice(1)}
                        {!!item?.productDetails?.inclusions?.inclusionCount ? (
                            <>
                                <span className="w-1.5 h-1.5 rounded-full bg-primary text-base mx-1.5"></span>{" "}
                            </>
                        ) : null}
                        {item?.productDetails?.inclusions?.inclusionCount > 0
                            ? ` ${
                                  item?.productDetails?.inclusions
                                      ?.inclusionCount
                              } Test${
                                  item?.productDetails?.inclusions
                                      ?.inclusionCount > 1
                                      ? "s"
                                      : ""
                              } included`
                            : ""}
                    </p>
                </div>

                <div className="col__2 text-primary font-normal">
                    {item?.productDetails?.category}
                </div>

                <div className="col__3 text-center place-self-center md:static absolute right-3 top-3">
                    <TestPrice
                        price={item?.productDetails?.cityPrice}
                        minPrice={item?.productDetails?.minPrice}
                        maxPrice={item?.productDetails?.maxPrice}
                        textColor={"text-black"}
                    />
                </div>

                <div className="col__3 text-center place-self-center md:relative absolute bottom-0 border-t md:border-0 border-bcolor left-0 right-0 py-1 md:py-0">
                    <span className="text-primary font-family-bold cursor-pointer md:text-base text-sm font-bold">
                        Book Now
                    </span>
                </div>
            </div>
        </Link>
    );
};

export default FindTestCard;
